import settingsApp from "./settings";
import httpApp from "./http";
import { useLocalStorage } from "@/libs/localStorage";
import { useCustomerStore } from "@/stores/customer";

const { getLocalStorageData, setLocalStorageData } = useLocalStorage();
const authApp = {
	isloggedIn: (
		forceCheck,
		fireReject = false,
		successCallback = null,
		failCallback = null
	) => {
		return new Promise(function (resolve, reject) {
			if (forceCheck) {
				httpApp
					.sendGetRequest(settingsApp.getEndpointUrl("isLoggedIn"))
					.then((response: any) => {
						if (response.success) {
							if (successCallback) {
								successCallback();
							}
							resolve(true);
						} else {
							if (failCallback) {
								failCallback();
							}
							resolve(false);
						}
					})
					.catch((error) => {
						if (failCallback) {
							failCallback();
						}
						if (fireReject) reject(error);
					});
			} else {
				const customerData = getLocalStorageData("customerData");
				if (customerData) {
					if (successCallback) {
						successCallback();
					}
					resolve(true);
				} else {
					resolve(false);
				}
			}
		});
	},

	login: (
		email,
		password,
		rememberMe = false,
		successCallback = null,
		failCallback = null
	) => {
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(settingsApp.getEndpointUrl("login"), {
					email: email,
					password: password,
					remember_me: rememberMe,
				})
				.then((response: any) => {
					if (response.success) {
						if (successCallback) {
							successCallback(response);
						}
						authApp.getCustomerData().then(() => {
							resolve(response);
						});
					} else {
						if (failCallback) {
							failCallback();
						}
						resolve(response);
					}
				})
				.catch((error) => {
					if (failCallback) {
						failCallback();
					}
					reject(error);
				});
		});
	},

	logout: (successCallback = null, failCallback = null) => {
		const customerStore = useCustomerStore();
		return new Promise(function (resolve, reject) {
			httpApp
				.sendGetRequest(settingsApp.getEndpointUrl("logout"))
				.then(() => {
					if (successCallback) {
						successCallback();
					}
					setLocalStorageData({
						customerData: null,
					});
					setLocalStorageData({
						sellerData: null,
					});
					customerStore.setCustomerData(null);
					customerStore.isLoggedIn = false;
					resolve(true);
				})
				.catch((error) => {
					if (failCallback) {
						failCallback();
					}
					reject(error);
				});
		});
	},

	getCustomerData: (fireReject = false) => {
		const customerStore = useCustomerStore();
		return new Promise(function (resolve, reject) {
			httpApp
				.sendGetRequest(
					settingsApp.getEndpointUrl("getLoginCustomerData")
				)
				.then((response: any) => {
					if (response.success) {
						customerStore.setCustomerData(response.data);
						customerStore.isLoggedIn = true;
						setLocalStorageData({
							customerData: response.data,
						});
						resolve(response);
					} else {
						setLocalStorageData({
							customerData: null,
						});
						setLocalStorageData({
							sellerData: null,
						});
						customerStore.setCustomerData(null);
						resolve(response);
					}
				})
				.catch((error) => {
					customerStore.setCustomerData(null);
					if (fireReject) reject(error);
				});
		});
	},

	forgotPassword: (email, successCallback = null, failCallback = null) => {
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(settingsApp.getEndpointUrl("forgotPassword"), {
					email,
				})
				.then((response: any) => {
					if (response.success) {
						if (successCallback) {
							successCallback(response);
						}
						resolve(response);
					} else {
						if (failCallback) {
							failCallback(response);
						}
						resolve(response);
					}
				})
				.catch((error) => {
					if (failCallback) {
						failCallback();
					}
					reject(error);
				});
		});
	},

	validateForgotPasswordToken: (
		confirmData,
		successCallback = null,
		failCallback = null
	) => {
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("validateForgotPasswordToken"),
					confirmData
				)
				.then((response: any) => {
					if (response.success) {
						if (successCallback) {
							successCallback(response);
						}
						resolve(response);
					} else {
						if (failCallback) {
							failCallback(response);
						}
						resolve(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	changeForgottenPassword: (
		data,
		successCallback = null,
		failCallback = null
	) => {
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("changeForgottenPassword"),
					data
				)
				.then((response: any) => {
					if (response.success) {
						if (successCallback) {
							successCallback(response);
						}
						resolve(response);
					} else {
						if (failCallback) {
							failCallback(response);
						}
						resolve(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	register: (formData, successCallback = null, failCallback = null) => {
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostFormData(
					settingsApp.getEndpointUrl("register"),
					formData
				)
				.then((response: any) => {
					if (response.success) {
						if (successCallback) {
							successCallback(response);
						}
						resolve(response);
					} else {
						if (failCallback) {
							failCallback(response);
						}
						resolve(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	confirmAccount: (
		confirmData,
		successCallback = null,
		failCallback = null
	) => {
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("confirmAccount"),
					confirmData
				)
				.then((response: any) => {
					if (response.success) {
						if (successCallback) {
							successCallback(response);
						}
						resolve(response);
					} else {
						if (failCallback) {
							failCallback(response);
						}
						resolve(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	editCustomer: (formData, successCallback = null, failCallback = null) => {
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostFormData(
					settingsApp.getEndpointUrl("editCustomer"),
					formData
				)
				.then((response: any) => {
					if (response.success) {
						if (successCallback) {
							successCallback(response);
						}
						resolve(response);
					} else {
						if (failCallback) {
							failCallback(response);
						}
						resolve(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};

export default authApp;
